import React from "react";
import styles from "./Button.module.css";

const Button = (props) => {
  const {
    type,
    clickHandler,
    label,
    disable,
    disabled,
    fullWidth,
    ...rest
  } = props;

  const isDisabled = Boolean(disable || disabled);

  const baseClass =
    type === "solid" ? styles.solid_btn : styles.outline_btn;

  const className = fullWidth
    ? `${styles.full_width} ${isDisabled ? styles.disable : baseClass}`
    : isDisabled
    ? styles.disable
    : baseClass;

  return (
    <button
      onClick={isDisabled ? undefined : clickHandler}
      className={className}
      disabled={isDisabled}
      aria-disabled={isDisabled}
      {...rest}
    >
      {label}
    </button>
  );
};

export default Button;